<template>
  <div class="public-preview">
    <div class="preview-header">
      证书预览
    </div>

    <div class="preview-tip">
      在线预览证书无公章，如需查看盖章证书请联系管理员。
    </div>

    <div class="preview-container" ref="previewWrap">
      <div v-if="previewLoading" class="preview-placeholder">正在加载证书预览……</div>
      <div v-else-if="previewImages.length" class="preview-images">
        <img v-for="(src, idx) in previewImages" :key="idx" :src="src" alt="证书预览" />
      </div>
      <div v-else class="preview-placeholder">{{ errorText || '暂无证书预览' }}</div>
    </div>
  </div>
</template>

<script>
import pdfjsWorker from 'pdfjs-dist/legacy/build/pdf.worker.entry';

export default {
  name: 'PublicCertificatePreview',
  data() {
    return {
      previewUrl: '',
      previewImages: [],
      previewLoading: false,
      errorText: '',
    };
  },
  mounted() {
    const pdfjsModule = require('pdfjs-dist/legacy/build/pdf.js');
    const pdfjsLib = pdfjsModule && pdfjsModule.default ? pdfjsModule.default : pdfjsModule;
    if (pdfjsLib && pdfjsLib.GlobalWorkerOptions) {
      pdfjsLib.GlobalWorkerOptions.workerSrc = pdfjsWorker;
    }
    const id = this.$route.query.id;
    const code = this.$route.query.code;
    if (!id || !code) {
      this.errorText = '参数缺失，无法预览';
      return;
    }
    const baseURL = process.env.NODE_ENV === 'development'
      ? 'https://test-dev.welamp.cn/api/home'
      : '/api/home';
    this.previewUrl = `${baseURL}/certificate/preview_public/${id}?code=${encodeURIComponent(code)}`;
    this.loadPreviewImages();
  },
  methods: {
    async loadPreviewImages() {
      if (!this.previewUrl) return;
      this.previewLoading = true;
      this.previewImages = [];
      try {
        const lower = this.previewUrl.toLowerCase();
        if (lower.endsWith('.png') || lower.endsWith('.jpg') || lower.endsWith('.jpeg')) {
          this.previewImages = [this.previewUrl];
          return;
        }
        const pdfjsModule = require('pdfjs-dist/legacy/build/pdf.js');
        const pdfjsLib = pdfjsModule && pdfjsModule.default ? pdfjsModule.default : pdfjsModule;
        const loadingTask = pdfjsLib.getDocument({
          url: this.previewUrl,
          withCredentials: false,
        });
        const pdf = await loadingTask.promise;
        const wrap = this.$refs.previewWrap;
        const targetWidth = wrap && wrap.clientWidth ? wrap.clientWidth : 841;
        const pages = pdf.numPages;
        for (let i = 1; i <= pages; i++) {
          const page = await pdf.getPage(i);
          const baseViewport = page.getViewport({ scale: 1 });
          const scale = targetWidth / baseViewport.width;
          const viewport = page.getViewport({ scale });
          const canvas = document.createElement('canvas');
          const context = canvas.getContext('2d');
          canvas.width = viewport.width;
          canvas.height = viewport.height;
          await page.render({ canvasContext: context, viewport }).promise;
          this.previewImages.push(canvas.toDataURL('image/png'));
        }
      } catch (e) {
        this.errorText = '证书预览加载失败';
      } finally {
        this.previewLoading = false;
      }
    },
  },
};
</script>

<style lang="less" scoped>
.public-preview {
  padding: 24px 16px 40px;
  max-width: 1100px;
  margin: 0 auto;
}

.preview-header {
  font-size: 20px;
  font-weight: 600;
  color: #333;
}

.preview-tip {
  margin-top: 10px;
  color: #666;
  font-size: 13px;
}

.preview-container {
  margin: 24px auto 0;
  width: 100%;
  max-width: 960px;
  min-height: 540px;
  border: 1px solid #e6e8f0;
  background: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
}

.preview-images {
  width: 100%;
}

.preview-images img {
  width: 100%;
  height: auto;
  display: block;
}

.preview-placeholder {
  color: #909399;
  font-size: 14px;
  padding: 24px 16px;
  text-align: center;
}
</style>
